import React, { Component } from 'react';
import { Form, Text, Select, Option } from 'informed';
import { CustomNav } from '../Components/CustomNav';
import { apiServerUrl } from '../config';
import { authHeader, requestOptions } from '../_helpers';
import { AppContext } from '../Pages/App';
import axios from 'axios';

export class AddUser extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  sendData(values) {
    console.log(values);
    console.log('sending data');
    axios
      .post(apiServerUrl + '/save_user', values, requestOptions())
      .then(function(response) {
        console.log(response);
      })
      .catch(function(error) {
        console.log(error);
      });
  }
  render() {
    return (
      <div>
        <header className="nav">
          <CustomNav />
        </header>

        <div
          style={{
            border: '5px solid red;',
            height: '50px',
            width: '300px',
            marginLeft: '100px',
            marginTop: '100px',
            color: 'white'
          }}
        >
          <h1>Add a User</h1>
          <Form
            id="intro-form"
            style={{ display: 'flex', flexDirection: 'column' }}
            onSubmit={this.sendData}
          >
            {/*account_type*/}
            <div>
              <label htmlFor="username">username:</label>
              <Text field="username" id="username" />
            </div>
            <div>
              <label htmlFor="password">password:</label>
              <Text field="password" id="password" />
            </div>
            <div>
              <label htmlFor="name">name:</label>
              <Text field="name" id="name" />
            </div>
            <div>
              <label htmlFor="email">email:</label>
              <Text field="email" id="email" />
            </div>
            <div>
              <label htmlFor="organization">organization:</label>
              <Text field="organization" id="organization" />
            </div>
            <div>
              <label htmlFor="team">team:</label>
              <Select field="team" id="team" style={{ color: 'black' }}>
                <AppContext.Consumer>
                  {context =>
                    context.number.map(item => (
                      <Option key={item.abbreviation} value={item.abbreviation}>
                        {item.full_team_name}
                      </Option>
                    ))
                  }
                </AppContext.Consumer>
              </Select>
            </div>
            <button type="submit" style={{ color: 'black' }}>
              Submit
            </button>
          </Form>
        </div>
      </div>
    );
  }
}

export default AddUser;



// WEBPACK FOOTER //
// ./src/Pages/AddUser.js